/** Release switch. No new offers, checkout entry or delivery telemetry before activation. Owner reports and withdrawal remain available. */
export const PROMOTIONS_ENABLED =
  process.env.NEXT_PUBLIC_PROMOTIONS_ENABLED === "true";
